export default __webpack_public_path__ + "static/media/img9.1415f1a8.png";